export default "__VITE_ASSET__bb5de58a__"